import { render } from "./AsyncModel.vue?vue&type=template&id=b8363b4a&scoped=true"
import script from "./AsyncModel.vue?vue&type=script&lang=js"
export * from "./AsyncModel.vue?vue&type=script&lang=js"

import "./AsyncModel.vue?vue&type=style&index=0&id=b8363b4a&scoped=true&lang=css"
import "./AsyncModel.vue?vue&type=style&index=1&id=b8363b4a&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8363b4a"]])

export default __exports__